module.exports = __webpack_public_path__ + "static/media/addbookcaegoryiconp.1d5dfc3a.svg";